export default function SvgLocationBg(props) {
    return (
        <svg {...props} viewBox="0 0 1087 245" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1084.81 179.568C1028.73 113.392 703.96 -61.8734 513.764 -20.9734C276.021 30.1516 697.49 292.134 298.028 235.191C224.763 224.748 153.032 205.347 84.715 180.412"
                stroke="url(#paint0_linear_963_547)" strokeWidth="3"/>
            <path d="M-417.161 -128.615C-336.664 -50.3748 -147.854 94.3725 79.4868 178.497"
                  stroke="url(#paint1_linear_963_547)" strokeWidth="3"/>
            <circle cx="79.5" cy="178.5" r="1.5" fill="currentColor"/>
            <defs>
                <linearGradient id="paint0_linear_963_547" x1="1034" y1="134" x2="178.552" y2="417.124"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" stopOpacity="0"/>
                    <stop offset="0.318313" stopColor="currentColor" stopOpacity="0.56"/>
                    <stop offset="1" stopColor="currentColor" stopOpacity="0"/>
                </linearGradient>
                <linearGradient id="paint1_linear_963_547" x1="-438.846" y1="-111.197" x2="-156.367" y2="328.55"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" stopOpacity="0"/>
                    <stop offset="1" stopColor="currentColor" stopOpacity="0.31"/>
                </linearGradient>
            </defs>
        </svg>
    )
}